module.exports = __webpack_public_path__ + "static/img/3208.63d9f8e0.jpg";